import { useState, useRef, useCallback, useMemo, useEffect } from "react";

import { Button, TableContainer, Typography } from "@mui/material";

import { Box } from "@mui/system";
import TableTheme from "themes/componentTheme/TableTheme";
import { IconFileTypeCsv } from "@tabler/icons-react";
import TableSearchInput from "components/ui-component/inputs/TableSearchInput";
import GridTableMain from "../GridTableMain";
import { calculateRemToPx } from "utils/utilsCommon";
import { useSelector } from "react-redux";
import { fetchESystemList } from "apis/Service";
import ButtonBox from "components/ui-component/box/ButtonBox";
import TableSearchDate from "components/ui-component/inputs/TableSearchDate";


export const ESystemTable = ({ vtableData }) => {
    // ********************************************
    //  데이터 관리
    // ********************************************
    const [tableData, setTableData] = useState(vtableData);
    const { selectCompanyNo } = useSelector(state => state.header);
    const [searchDateStr, setSearchDateStr] = useState('');
    const [searchDateEnd, setSearchDateEnd] = useState('');


    // ********************************************
    //  그리드
    // ********************************************
    const rowHeight = calculateRemToPx(2);
    const numberOfRows = 50; // 표시할 행 수
    const selectableNumberOfRows = [10, 50, 100]
    const headerHeight = calculateRemToPx(2.5);

    const gridRef = useRef();

    const [columnDefs] = useState([
        {
            field: 'no', headerName: 'No',
            hide: true // AGGrid 안보이게 설정
        },
        { field: 'employeeNo', headerName: '사원번호', flex: 5 },
        { field: 'employeeName', headerName: '사원명', flex: 5 },
        { field: 'applyDate', headerName: '신청일자', flex: 10 },
        { 
            field: 'startDate', 
            headerName: '시작일', 
            flex: 10,
            cellRenderer: (params) => {
                return params.value || '';
            }
        },
        { 
            field: 'endDate', 
            headerName: '종료일', 
            flex: 10,
            cellRenderer: (params) => {
                return params.value || '';
            }
        },
        { field: 'typeStr', headerName: '종류', flex: 5 },
        { field: 'title', headerName: '제목', flex: 30 },
        { field: 'statusStr', headerName: '상태', flex: 5 },
    ]);

    const defaultColDef = useMemo(() => {
        return {
            sortable: true,
            filter: true,
            resizable: true,
        };
    }, []);

    const gridOptions = {
        alwaysMultiSort: true,
        rowHeight: rowHeight,
        headerHeight: headerHeight,
        pagination: true,
        paginationPageSize: numberOfRows,
        paginationPageSizeSelector: selectableNumberOfRows,
        domLayout: 'autoHeight',
    };

    const onGridReady = (params) => {
        gridRef.current = params.api; // AG Grid API를 gridRef에 저장
    };

    const onBtnExport = useCallback(() => {
        if (gridRef.current) {
            // api가 정의되어 있을 때만 exportDataAsCsv를 호출
            gridRef.current.exportDataAsCsv();
        }
    }, []);

    const [searchText, setSearchText] = useState(''); // 검색어 상태 추가

    const handleSearch = (value) => {
        setSearchText(value);
    }

    useEffect(() => {
        setTableData(vtableData);
    }, [vtableData]);

    const handleDateStrChange = (date) => {
        setSearchDateStr(date);
    }

    const handleDateEndChange = (date) => {
        setSearchDateEnd(date);
    }

    return (
        <TableTheme>
            <TableContainer id='printableArea' sx={{ padding: '0' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '0.5rem 0' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>

                        <ButtonBox sx={{ display: 'flex', justifyContent: '', padding: '0.5rem 0' }} className="print-header">
                            <Button variant="outlined" size="small" onClick={onBtnExport}><IconFileTypeCsv /><Typography variant="subtitle" sx={{ padding: '0 0.25rem' }}>다운로드</Typography></Button>

                            <TableSearchDate onDateChange={handleDateStrChange} label='시작일' />
                            <Typography variant="subtitle" >~</Typography>
                            <TableSearchDate onDateChange={handleDateEndChange} label='종료일' />
                        </ButtonBox>
                    </Box>
                    <Box>
                        <TableSearchInput onSearch={handleSearch} />
                    </Box>

                </Box>
                <GridTableMain
                    box_style={{ height: '100%', width: '100%' }}
                    style={{ textAlign: 'center' }}
                    onGridReady={onGridReady}
                    ref={gridRef}
                    defaultColDef={defaultColDef}
                    rowData={tableData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </TableContainer>
        </TableTheme>
    );
};
export default ESystemTable;
